import './ErrorInfiniteRetry.scss';

import { Offline, Online } from 'react-detect-offline';

import Button from '../Button';
import icon_loading from '../../assets/images/icon_loadingBlue.svg';
import { motion } from 'framer-motion';

// axios error shape: HTTP-ответ от сервера лежит в `error.response`. При network/timeout/CORS/DNS
// сбоях `error.response` отсутствует — этим и разделяем сообщения для пользователя.
type MaybeAxiosError = { response?: unknown } & Record<string, unknown>;

interface Props {
  resetStateErrors?: () => void;
  error?: MaybeAxiosError | null;
}

export const ErrorInfiniteRetry: React.FC<Props> = ({ resetStateErrors, error }) => {
  if (error) {
    const hasResponse = !!error.response;

    return (
      <div className='errorInfiniteRetry'>
        {hasResponse ? (
          <>
            <motion.img src={icon_loading} initial={{ rotate: 0 }} animate={{ rotate: 360 }} transition={{ duration: 2, loop: Infinity, ease: 'linear' }} />
            <br />
            <div className='errorMessage'>
              На сервере технические проблемы. <br />
              Приносим извинения за неудобства. В ближайшее время мы восстановим работу системы. <br />
              <br />
              Попробуйте перезагрузить страницу через несколько минут. <br />
              Если ошибка остаётся - свяжитесь с администратором.
            </div>
          </>
        ) : (
          <>
            <div className='errorMessage'>
              Потеряна связь с сервером. <br />
              Проверьте подключение к интернету и обновите страницу.
            </div>
            <Button
              type='button'
              buttonType='button'
              width='280rem'
              size='medium'
              color='blue'
              className='reloadButton'
              text='Обновить страницу'
              onClick={() => window.location.reload()}
            />
          </>
        )}
      </div>
    );
  }

  // Без error — старый fallback: браузерный online/offline-флаг.
  return (
    <div className='errorInfiniteRetry'>
      <motion.img src={icon_loading} initial={{ rotate: 0 }} animate={{ rotate: 360 }} transition={{ duration: 2, loop: Infinity, ease: 'linear' }} />
      <br />
      <Online>
        <div className='errorMessage'>
          На сервере технические проблемы. <br />
          Приносим извинения за неудобства. В ближайшее время мы восстановим работу системы. <br />
          <br />
          Попробуйте перезагрузить страницу через несколько минут. <br />
          Если ошибка остаётся - свяжитесь с администратором.
        </div>
      </Online>
      <Offline onChange={resetStateErrors}>
        <div className='errorMessage'>
          Проблемы с интернет соединением.
          <br /> Пытаемся переподключиться. Если ошибка остается - свяжитесь с администратором.
        </div>
      </Offline>
    </div>
  );
};
